import React from 'react';
import Playlist from '../Playlist';
import './selected-playlist-carousel.scss';

// ///Import Buttons
import { LEFT, RIGHT, DOWN, BACK, ENTER } from '../../util/remoteButtons';

export default class SelectedPlaylistCarousel extends React.Component {
  constructor(props) {
    super(props);
    const playlist = props.playlist ? props.playlist : [];
    this.state = {
      current: props.currentPlaylist === 0 ? parseInt(playlist.length / 2) : props.currentPlaylist,
      show: false,
      playlists: playlist,
      playlistName: playlist.name,
      artNo: 2,
      highquality: 'high',
      firstPlaylist: 0,
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    
  }

  componentDidMount() {
    // this.setList();
  }

  setList() {
    const { current, playlists } = this.state;
    if (current == playlists.length - 1 || current == playlists.length - 2) {
      const newArray = this.state.playlists.slice();
      for (let i = 0; i < playlists.length; i++) {
        newArray.push(playlists[i]);
        this.setState({
          playlists: newArray
        });
      }
    }
  }

  handleKeyDown(e) {
    switch (e.which) {
      case ENTER:
        this.props.getArtworkFromPlaylist(this.state.playlists[this.state.current].playlistId);
        break;
      case LEFT:
        this.prev();
        break;
      case RIGHT:
        this.next();
        break;
      case 10182:
        this.props.onExitApp();
        break;
    }
  }

  handleClick(count) {
    this.getArtworkFromPlaylist(count);
  }

  next() {
    const newArray = this.state.playlists.slice(0);
    newArray.push(newArray.shift());
    this.props.setCurrent(this.state.playlists[this.state.current + 1].playlistId);
    this.setState({
      playlists: newArray
    });
  }

  prev() {
    const slides = this.state.playlists.slice(0);
    slides.unshift(slides.pop());
    this.props.setCurrent(this.state.playlists[this.state.current - 1].playlistId);
    this.setState({ playlists: slides });
  }

  render() {
    const { current, artNo } = this.state;
    const { playlists } = this.state || {};
    if (!playlists) {
      return null;
    }
    let left = (-(current*22) + 14.5);
    const slides = playlists.map((item, idx) => {
        left += 22;
        return (
          <div key={idx} className="selected-carousel__slide" style={{ left: `${left}%` }}>
            <Playlist key={idx} handleClick={this.handleClick} showDetails={idx === current} playlist={item} />
          </div>
        );
    });

    return (
      <div
        tabIndex="2"
        className="selected-carousel"
        ref="carousel"
        onKeyDown={this.handleKeyDown}
        onBlur={() => this.setState({ show: false })}
      >
        {slides}
      </div>
    );
  }
}
